export const Data = [
  {
    type: "zh",
    backgroundImage: "https://www.victrum.com/image/sy/cpjsb.jpg",
    cpjsTitle:"产品介绍",
    cpjsMore:"查看更多",
    cpjsItem:[
      {
        path: "e",
        index:1,
        showData:true,
        imgUrl:"https://www.victrum.com/image/tp/产品介绍-左.png",
        text1:"口腔Er:YAG激光治疗仪",
        text2:"采用军工级别的Er:YAG晶体，产生波长为2940nm的激光，通过手机动态聚焦技术与口腔组织中水分子\n" +
          "的作用，产生“微爆破”反应，实现口腔软、硬组织的汽化，消融切割等治疗效果。"
      },
      {
        path: "gzj",
        index:2,
        showData:true,
        imgUrl:"https://www.victrum.com/image/tp/产品介绍-中.png",
        text1:"激光全能手机",
        text2:"采取直弯头设计，可实现全方位多角度的诊疗模式，可360度旋转，灵活轻巧。"
      },
      {
        path: "sb",
        index:3,
        showData:true,
        imgUrl:"https://www.victrum.com/image/tp/产品介绍-右.png",
        text1:"激光工作尖",
        text2:"非侵入式及吸附锁式设计，达到即插即用，拥有各种直径和长度的规格，可接受高温消毒，实现重复使用，降低使用成本。"
      }
    ]
  },
  {
    type: "en",
    backgroundImage:"https://www.victrum.com/image/sy/cpjsb.jpg",
    cpjsTitle:"Product Introduction",
    cpjsMore:"View More",
    cpjsItem:[
      {
        path: "cpjs",

        index:1,
        showData:true,
        imgUrl:"https://www.victrum.com/image/tp/产品介绍-左.png",
        text1:"Er:YAG \n" +
          "Dental Laser \n" +
          "Treatment System",
        text2:"Using military grade Er: YAG crystal, a laser with a wavelength of 2940nm is generated, which is then dynamically focused on..."
      },
      {
        path: "gzj",
        index:2,
        showData:true,
        imgUrl:"https://www.victrum.com/image/tp/产品介绍-中.png",
        text1:"All-in-One Laser Handpiece",
        text2:"Adopting a straight bend design, it can achieve a comprehensive and multi angle diagnosis and treatment mode"
      },
      {
        path: "sb",
        index:3,
        showData:true,
        imgUrl:"https://www.victrum.com/image/tp/产品介绍-右.png",
        text1:"Laser Working Tips",
        text2:"Non invasive and adsorption lock design, achieving plug and play, with various diameter and length specifications, can accept high temperature disinfection, achieve reuse, and reduce usage costs."
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/components/js/image/cpjs.js